import styled from "styled-components";

export const Layer = styled.div`
  height: 100%;
  position: relative;
`